/**
 * Settings Page Translations
 */

import { Translations } from '../shared/i18n';

export const settingsTranslations: Translations = {
    tr: {
        navSettings: 'Ayarlar',
        settingsTitle: 'Ayarlar',
        settingsDescription: 'Hesap ve uygulama ayarlarınızı yönetin.',

        // Tab labels
        tabProfile: 'Profil',
        tabSecurity: 'Güvenlik',
        tabTheme: 'Tema',
        tabLanguage: 'Dil',
        tabSubscription: 'Abonelik',
        tabUsage: 'Kullanım',
        tabAccount: 'Hesap',
        tabFiles: 'Dosyalar',
        tabDisplay: 'Görünüm',

        // Categories tab
        tabCategories: 'Kategoriler',
        catTitle: 'Gider Kategorileri',
        catDescription: 'Faturalarınız için kullanılan gider kategorilerini özelleştirin. LLM bu kategorileri OCR sırasında otomatik atama için kullanır.',
        catColLabel: 'Kategori Adı',
        catColDesc: 'Açıklama (LLM Tanımlayıcısı)',
        catLabelPlaceholder: 'Kategori adı',
        catLabelEn: 'İngilizce Etiket',
        catDescPlaceholder: 'Hangi tür harcamaları kapsar?',
        catEdit: 'Düzenle',
        catDelete: 'Sil',
        catAddRow: 'Satır Ekle',
        catImport: 'İçe Aktar',
        catImportTitle: 'Kategorileri İçe Aktar',
        catImportDesc: 'Her satıra bir kategori yazın. Açıklama eklemek için | veya = ayırıcı kullanın.',
        catImportPlaceholder: 'Kategori Adı | Açıklama\nKategori Adı = Açıklama\nSadece Kategori Adı',
        catImportBtn: 'Ekle',
        catCancelBtn: 'İptal',
        catSave: 'Kaydet',
        catSaving: 'Kaydediliyor...',
        catSaved: 'Kategoriler başarıyla kaydedildi.',
        catError: 'Kategoriler kaydedilirken hata oluştu.',
        catResetBtn: 'Varsayılanlara Sıfırla',
        catResetConfirm: 'Tüm özel kategorileriniz silinecek ve varsayılanlara dönülecek. Emin misiniz?',
        catResetDone: 'Kategoriler varsayılanlara sıfırlandı.',
        catUnsavedChanges: 'Kaydedilmemiş değişiklikler var',
        catKeyDuplicate: 'Bu anahtar zaten mevcut',

        // DATEV settings
        tabDatev: 'DATEV',
        datevTitle: 'DATEV Export Ayarları',
        datevDesc: 'Mali müşavirinize DATEV formatında veri göndermek için bu ayarları yapılandırın.',
        datevBeraternr: 'Beraternummer',
        datevMandantennr: 'Mandantennummer',
        datevWjBeginn: 'Mali Yıl Başlangıcı',
        datevSachkontenlaenge: 'Sachkontenlänge',
        datevGegenkonto: 'Gegenkonto',
        datevSkrType: 'Kontenrahmen',
        datevSave: 'Kaydet',
        datevSaving: 'Kaydediliyor...',
        datevSaved: 'DATEV ayarları kaydedildi.',
        datevError: 'DATEV ayarları kaydedilemedi.',
        datevBeraternrHint: '4-7 haneli sayı, min. 1001',
        datevMandantennrHint: '1-5 haneli sayı',
        datevGegenkontoHint: 'Sadece rakam',

        // DATEV SKR Chart of Accounts (Kontenrahmen)
        datevChartTitle: 'SKR Hesap Planı (Kontenrahmen)',
        datevChartDesc: 'DATEV export\'ta kullanılan resmi hesap planı. Buradaki listeden satır ekleyebilir, silebilir veya düzenleyebilirsiniz. Yapay zeka, faturalara hesap atarken sadece bu listedeki numaralardan birini seçer.',
        datevChartColKonto: 'Hesap No',
        datevChartColLabel: 'Açıklama',
        datevChartColActions: '',
        datevChartAddRow: '+ Satır Ekle',
        datevChartDeleteRow: 'Sil',
        datevChartResetBtn: 'Varsayılana Sıfırla',
        datevChartResetConfirm: 'Tüm SKR03 ve SKR04 değişiklikleri silinecek ve varsayılan listeye dönülecek. Emin misiniz?',
        datevChartResetDone: 'Hesap planı varsayılana sıfırlandı.',
        datevChartSaved: 'Hesap planı kaydedildi.',
        datevChartInvalid: 'Hesap numarası sadece rakam olmalı; açıklama boş bırakılamaz.',
        datevChartDuplicate: 'Aynı hesap numarası birden fazla kez kullanılamaz.',
        datevChartEmpty: 'Listede en az bir hesap olmalıdır.',

        unsavedTitle: 'Kaydedilmemiş Değişiklikler',
        unsavedMessage: 'Kaydedilmemiş değişiklikleriniz var. Sayfadan ayrılırsanız bu değişiklikler kaybolacak.',
        unsavedLeave: 'Ayrıl',
        unsavedStay: 'Kal',

        // Theme section
        themeSection: 'Tema Tercihi',
        themeDescription: 'Arayüzünüzün görünümünü seçin.',
        themeLight: 'Açık',
        themeDark: 'Koyu',
        themeSystem: 'Sistem',
        themeLightDesc: 'Klasik beyaz arayüz',
        themeDarkDesc: 'Göz yormayan koyu arayüz',
        themeSystemDesc: 'Cihaz ayarını takip et',

        // Profile section
        profileSection: 'Profil Bilgileri',
        profileName: 'Ad Soyad',
        profileEmail: 'Email Adresi',
        profileSave: 'Değişiklikleri Kaydet',
        profileSaving: 'Kaydediliyor...',
        profileSuccess: 'Profil başarıyla güncellendi.',
        profileError: 'Profil güncellenirken hata oluştu.',
        profileEmailInvalid: 'Lütfen geçerli bir e-posta adresi girin.',

        // Profile photo
        profilePhoto: 'Profil Fotoğrafı',
        uploadPhoto: 'Fotoğraf Yükle',
        removePhoto: 'Kaldır',
        photoUpdated: 'Fotoğraf güncellendi.',
        photoError: 'Fotoğraf yüklenirken hata oluştu.',
        photoTooLarge: 'Fotoğraf çok büyük. Maksimum 5MB.',

        // Password section
        passwordSection: 'Şifre Değiştir',
        passwordDescription: 'Hesabınızı güvende tutmak için güçlü bir şifre kullanın.',
        setPasswordSection: 'Şifre Belirle',
        setPasswordDesc: 'SSO ile giriş yaptığınız için henüz bir şifre belirlemediniz. Email ile de giriş yapabilmek için şifre belirleyin.',
        setPasswordButton: 'Şifre Belirle',
        settingPassword: 'Belirleniyor...',
        setPasswordSuccess: 'Şifreniz başarıyla belirlendi.',
        currentPassword: 'Mevcut Şifre',
        newPassword: 'Yeni Şifre',
        confirmPassword: 'Yeni Şifre (Tekrar)',
        changePassword: 'Şifreyi Değiştir',
        changingPassword: 'Değiştiriliyor...',
        passwordSuccess: 'Şifreniz başarıyla değiştirildi.',
        passwordError: 'Şifre değiştirilirken hata oluştu.',
        passwordMismatch: 'Şifreler eşleşmiyor.',
        passwordTooShort: 'Şifre en az 8 karakter olmalıdır.',
        passwordWrong: 'Mevcut şifre yanlış.',

        // Language section
        languageSection: 'Dil Tercihi',
        languageDescription: 'Uygulamanın görüntüleneceği dili seçin.',
        languageTurkish: 'Türkçe',
        languageEnglish: 'English',
        languageGerman: 'Deutsch',

        // Date format section
        dateFormatSection: 'Tarih Formatı',
        dateFormatDescription: 'Tarihlerin nasıl görüntüleneceğini seçin.',

        // Display currency section
        displayCurrencySection: 'Görüntüleme Para Birimi',
        displayCurrencyDescription: 'Tutarların varsayılan olarak gösterileceği para birimini seçin.',

        // Subscription section
        subscriptionSection: 'Abonelik ve Krediler',
        subscriptionDesc: 'Mevcut planınız ve kredi satın alma seçenekleri.',
        currentPlan: 'Mevcut Plan',
        planFree: 'Ücretsiz Plan',
        freePlanDesc: 'Aylık 50 belge yükleme + 5 eşleştirme',
        freePlanFeature1: 'Aylık 50 belge yükleme',
        freePlanFeature2: 'Aylık 5 eşleştirme',
        freePlanFeature3: 'Otomatik dönem yenileme',
        creditPackBadge: 'Kredi Paketi',
        creditPackTitle: 'Kredi Satın Al',
        buyExtraCredits: 'Ek Kredi Satın Al',
        creditPackDesc: '€3 = 50 belge yükleme kredisi',
        creditFeature1: '€3 = 50 yükleme kredisi',
        monthlyUsage: 'Aylık Kullanım',
        usageDescLifetime: 'Hesap kullanım durumunuz.',
        documentUploads: 'Belge Yükleme',
        creditFeature2: 'Tutarı kendiniz belirleyin',
        creditFeature3: 'Krediler süresiz geçerli',
        creditPackScaleNote: 'Tutarı kendiniz belirleyin. krediler orantılı hesaplanır.',
        creditPackPrice: '$5\'den başlayan',
        buyCredits: 'Kredi Satın Al',
        checkoutLoading: 'Yönlendiriliyor...',
        checkoutError: 'Ödeme sayfası oluşturulamadı.',
        paymentSuccess: 'Ödeme başarılı! Kredileriniz eklendi.',
        paymentCancelled: 'Ödeme iptal edildi.',
        paymentProcessing: 'Ödeme alındı, işleniyor — birkaç saniye içinde hesabınıza yansıyacak.',
        historyTitle: 'Satın Alma Geçmişi',
        historyEmpty: 'Henüz satın alma geçmişi yok.',
        historyDate: 'Tarih',
        historyAmount: 'Tutar',
        historyCredits: 'Krediler',
        historyStatus: 'Durum',
        historyUploads: 'yükleme',
        historyRegenerates: 'yeniden işleme',
        historyPerMonth: 'ay',
        historyStatus_completed: 'Tamamlandı',
        historyStatus_pending: 'Bekliyor',
        historyStatus_failed: 'Başarısız',

        // Usage section
        usageTitle: 'Aylık Kullanım',
        usageDescription: 'Mevcut dönem kullanım durumunuz.',
        freePlanUploads: 'Ücretsiz Belge Yükleme',
        freePlanRematches: 'Ücretsiz Eşleştirme',
        usageResetsIn: '{days} gün sonra sıfırlanır',
        usageUsed: 'kullanıldı',
        paidUploads: 'Satın Alınan Yükleme Kredisi',
        paidRegenerates: 'Satın Alınan Yeniden İşleme Kredisi',
        usageLoadError: 'Kullanım verileri yüklenemedi.',
        loading: 'Yükleniyor...',
        quotaExceeded: 'Kotanız doldu. Devam etmek için kredi satın alın.',
        quotaModalTitle: 'Yükleme Limiti Doldu',
        quotaModalFree: 'Ücretsiz yükleme hakkınız tükendi. Devam etmek için planınızı yükseltin.',
        quotaModalPaid: 'Yükleme krediniz tükendi. Ek kredi satın alabilir veya sıfırlanmasını bekleyebilirsiniz.',
        quotaModalUsed: 'Kullanılan',
        quotaModalCredits: 'Kalan kredi',
        quotaModalResets: 'Kotanız {days} gün sonra sıfırlanacak ({date})',
        quotaModalUpgrade: 'Planı Yükselt',
        quotaModalBuyCredits: 'Kredi Satın Al',
        quotaModalClose: 'Kapat',
        subscribe: 'Abone Ol',
        buyReconciliation: 'Kredi Satın Al',
        cancelSubscription: 'Aboneliği İptal Et',
        cancelSubscriptionConfirm: 'Emin misiniz? Aboneliğiniz mevcut dönem sonunda yenilenmeyecek. O zamana kadar tüm özellikleri kullanmaya devam edebilirsiniz. Dönem bitince hesabınız Ücretsiz plana geçecektir.',
        managePayment: 'Ödeme Yönet',

        // Account section
        accountSection: 'Hesap Bilgileri',
        accountType: 'Hesap Tipi',
        accountTypeB2C: 'Bireysel',
        memberId: 'Üye No',
        memberSince: 'Kayıt Tarihi',
        deleteAccountBtn: 'Hesabı Sil',
        deleteAccountTitle: 'Hesabı Sil',
        deleteAccountWarning: 'Bu işlem kalıcıdır ve geri alınamaz. Verileriniz korunacak ancak hesabınız devre dışı bırakılacaktır.',
        deleteAccountTypeHint: 'Onaylamak için "delete" yazın',
        deleteAccountTypePlaceholder: 'delete',
        deleteAccountDeleting: 'Siliniyor...',
        deleteAccountConfirm: 'Hesabımı Sil',
        deleteAccountCancel: 'Vazgeç',
        deleteAccountError: 'Bir şeyler ters gitti. Lütfen tekrar deneyin.',
        deleteAccountFinalMessage: 'Kesinlikle emin misiniz? Bu işlem geri alınamaz.',
        deleteAccountFinalConfirm: 'Evet, Hesabımı Sil',
    },
    en: {
        navSettings: 'Settings',
        settingsTitle: 'Settings',
        settingsDescription: 'Manage your account and application settings.',

        // Tab labels
        tabProfile: 'Profile',
        tabSecurity: 'Security',
        tabTheme: 'Theme',
        tabLanguage: 'Language',
        tabSubscription: 'Subscription',
        tabUsage: 'Usage',
        tabAccount: 'Account',
        tabFiles: 'Files',
        tabDisplay: 'Display',

        // Categories tab
        tabCategories: 'Categories',
        catTitle: 'Expense Categories',
        catDescription: 'Customize expense categories used for your invoices. The LLM uses these to auto-assign categories during OCR.',
        catColLabel: 'Category Name',
        catColDesc: 'Description (LLM Hint)',
        catLabelPlaceholder: 'Category name',
        catLabelEn: 'English Label',
        catDescPlaceholder: 'What types of expenses does this cover?',
        catEdit: 'Edit',
        catDelete: 'Delete',
        catAddRow: 'Add Row',
        catImport: 'Import',
        catImportTitle: 'Import Categories',
        catImportDesc: 'Enter one category per line. Use | or = separator to add a description.',
        catImportPlaceholder: 'Category Name | Description\nCategory Name = Description\nJust Category Name',
        catImportBtn: 'Add',
        catCancelBtn: 'Cancel',
        catSave: 'Save',
        catSaving: 'Saving...',
        catSaved: 'Categories saved successfully.',
        catError: 'Error saving categories.',
        catResetBtn: 'Reset to Defaults',
        catResetConfirm: 'All custom categories will be removed and defaults restored. Are you sure?',
        catResetDone: 'Categories reset to defaults.',
        catUnsavedChanges: 'You have unsaved changes',
        catKeyDuplicate: 'This key already exists',

        // DATEV settings
        tabDatev: 'DATEV',
        datevTitle: 'DATEV Export Settings',
        datevDesc: 'Configure these settings to export data in DATEV format for your tax advisor.',
        datevBeraternr: 'Advisor Number (Beraternummer)',
        datevMandantennr: 'Client Number (Mandantennummer)',
        datevWjBeginn: 'Fiscal Year Start',
        datevSachkontenlaenge: 'Account Number Length',
        datevGegenkonto: 'Contra Account (Gegenkonto)',
        datevSkrType: 'Chart of Accounts',
        datevSave: 'Save',
        datevSaving: 'Saving...',
        datevSaved: 'DATEV settings saved.',
        datevError: 'Failed to save DATEV settings.',
        datevBeraternrHint: '4-7 digit number, min. 1001',
        datevMandantennrHint: '1-5 digit number',
        datevGegenkontoHint: 'Numbers only',

        // DATEV SKR Chart of Accounts (Kontenrahmen)
        datevChartTitle: 'SKR Chart of Accounts (Kontenrahmen)',
        datevChartDesc: 'The official chart used in DATEV export. Add, remove, or edit accounts in this list. The AI picks Sachkonto values only from this list when extracting invoices.',
        datevChartColKonto: 'Account No.',
        datevChartColLabel: 'Description',
        datevChartColActions: '',
        datevChartAddRow: '+ Add Row',
        datevChartDeleteRow: 'Delete',
        datevChartResetBtn: 'Reset to Defaults',
        datevChartResetConfirm: 'All SKR03 and SKR04 changes will be removed and the defaults restored. Are you sure?',
        datevChartResetDone: 'Chart of accounts reset to defaults.',
        datevChartSaved: 'Chart of accounts saved.',
        datevChartInvalid: 'Account number must be numeric; description is required.',
        datevChartDuplicate: 'The same account number cannot be used twice.',
        datevChartEmpty: 'The list must contain at least one account.',

        unsavedTitle: 'Unsaved Changes',
        unsavedMessage: 'You have unsaved changes. If you leave this page, your changes will be lost.',
        unsavedLeave: 'Leave',
        unsavedStay: 'Stay',

        // Theme section
        themeSection: 'Theme Preference',
        themeDescription: 'Choose the appearance of your interface.',
        themeLight: 'Light',
        themeDark: 'Dark',
        themeSystem: 'System',
        themeLightDesc: 'Classic white interface',
        themeDarkDesc: 'Easy on the eyes dark interface',
        themeSystemDesc: 'Follow device setting',

        // Profile section
        profileSection: 'Profile Information',
        profileName: 'Full Name',
        profileEmail: 'Email Address',
        profileSave: 'Save Changes',
        profileSaving: 'Saving...',
        profileSuccess: 'Profile updated successfully.',
        profileError: 'Error updating profile.',
        profileEmailInvalid: 'Please enter a valid email address.',

        // Profile photo
        profilePhoto: 'Profile Photo',
        uploadPhoto: 'Upload Photo',
        removePhoto: 'Remove',
        photoUpdated: 'Photo updated.',
        photoError: 'Error uploading photo.',
        photoTooLarge: 'Photo too large. Maximum 5MB.',

        // Password section
        passwordSection: 'Change Password',
        passwordDescription: 'Use a strong password to keep your account secure.',
        setPasswordSection: 'Set Password',
        setPasswordDesc: 'You signed in via SSO and haven\'t set a password yet. Set one to also log in with email.',
        setPasswordButton: 'Set Password',
        settingPassword: 'Setting...',
        setPasswordSuccess: 'Password set successfully.',
        currentPassword: 'Current Password',
        newPassword: 'New Password',
        confirmPassword: 'Confirm New Password',
        changePassword: 'Change Password',
        changingPassword: 'Changing...',
        passwordSuccess: 'Password changed successfully.',
        passwordError: 'Error changing password.',
        passwordMismatch: 'Passwords do not match.',
        passwordTooShort: 'Password must be at least 8 characters.',
        passwordWrong: 'Current password is incorrect.',

        // Language section
        languageSection: 'Language',
        languageDescription: 'Choose the language for the application.',
        languageTurkish: 'Türkçe',
        languageEnglish: 'English',
        languageGerman: 'Deutsch',

        // Date format section
        dateFormatSection: 'Date Format',
        dateFormatDescription: 'Choose how dates are displayed.',

        // Display currency section
        displayCurrencySection: 'Display Currency',
        displayCurrencyDescription: 'Choose the default currency for showing amounts.',

        // Subscription section
        subscriptionSection: 'Subscription & Credits',
        subscriptionDesc: 'Your current plan and credit purchase options.',
        currentPlan: 'Current Plan',
        planFree: 'Free Plan',
        freePlanDesc: '50 uploads/month + 5 rematches/month',
        freePlanFeature1: '50 document uploads per month',
        freePlanFeature2: '5 rematches per month',
        freePlanFeature3: 'Automatic period renewal',
        creditPackBadge: 'Credit Pack',
        creditPackTitle: 'Buy Credits',
        buyExtraCredits: 'Buy Extra Credits',
        creditPackDesc: '€3 = 50 document upload credits',
        creditFeature1: '€3 = 50 upload credits',
        monthlyUsage: 'Monthly Usage',
        usageDescLifetime: 'Your account usage.',
        documentUploads: 'Document Uploads',
        creditFeature2: 'Choose your own amount',
        creditFeature3: 'Credits never expire',
        creditPackScaleNote: 'Choose your own amount. credits scale proportionally.',
        creditPackPrice: 'Starting at $5',
        buyCredits: 'Buy Credits',
        checkoutLoading: 'Redirecting...',
        checkoutError: 'Could not create checkout session.',
        paymentSuccess: 'Payment successful! Your credits have been added.',
        paymentCancelled: 'Payment was cancelled.',
        paymentProcessing: 'Payment received — finalizing. Your account will update in a few seconds.',
        historyTitle: 'Purchase History',
        historyEmpty: 'No purchase history yet.',
        historyDate: 'Date',
        historyAmount: 'Amount',
        historyCredits: 'Credits',
        historyStatus: 'Status',
        historyUploads: 'uploads',
        historyRegenerates: 'regenerates',
        historyPerMonth: 'month',
        historyStatus_completed: 'Completed',
        historyStatus_pending: 'Pending',
        historyStatus_failed: 'Failed',

        // Usage section
        usageTitle: 'Monthly Usage',
        usageDescription: 'Your current period usage status.',
        freePlanUploads: 'Free Uploads',
        freePlanRematches: 'Free Rematches',
        usageResetsIn: 'Resets in {days} days',
        usageUsed: 'used',
        paidUploads: 'Purchased Upload Credits',
        paidRegenerates: 'Purchased Regenerate Credits',
        usageLoadError: 'Could not load usage data.',
        loading: 'Loading...',
        quotaExceeded: 'Quota exceeded. Purchase credits to continue.',
        quotaModalTitle: 'Upload Limit Reached',
        quotaModalFree: 'You have used all your free uploads. Upgrade your plan to continue.',
        quotaModalPaid: 'Your upload credits are exhausted. You can purchase more or wait for the reset.',
        quotaModalUsed: 'Used',
        quotaModalCredits: 'Credits remaining',
        quotaModalResets: 'Your quota resets in {days} days ({date})',
        quotaModalUpgrade: 'Upgrade Plan',
        quotaModalBuyCredits: 'Buy Credits',
        quotaModalClose: 'Close',
        subscribe: 'Subscribe',
        buyReconciliation: 'Buy Credits',
        cancelSubscription: 'Cancel Subscription',
        cancelSubscriptionConfirm: 'Are you sure? Your subscription will not renew at the end of the current billing period. You can continue using all features until then. After that, your account will switch to the Free plan.',
        managePayment: 'Manage Payment',

        // Account section
        accountSection: 'Account Information',
        accountType: 'Account Type',
        accountTypeB2C: 'Individual',
        memberId: 'Member ID',
        memberSince: 'Member Since',
        deleteAccountBtn: 'Delete Account',
        deleteAccountTitle: 'Delete Account',
        deleteAccountWarning: 'This action is permanent and cannot be undone. Your data will be retained but your account will be deactivated.',
        deleteAccountTypeHint: 'Type "delete" to confirm',
        deleteAccountTypePlaceholder: 'delete',
        deleteAccountDeleting: 'Deleting...',
        deleteAccountConfirm: 'Delete My Account',
        deleteAccountCancel: 'Cancel',
        deleteAccountError: 'Something went wrong. Please try again.',
        deleteAccountFinalMessage: 'Are you absolutely sure? This cannot be undone.',
        deleteAccountFinalConfirm: 'Yes, Delete My Account',
    },
    de: {
        navSettings: 'Einstellungen',
        settingsTitle: 'Einstellungen',
        settingsDescription: 'Verwalten Sie Ihre Konto- und Anwendungseinstellungen.',

        // Tab labels
        tabProfile: 'Profil',
        tabSecurity: 'Sicherheit',
        tabTheme: 'Design',
        tabLanguage: 'Sprache',
        tabSubscription: 'Abonnement',
        tabUsage: 'Nutzung',
        tabAccount: 'Konto',
        tabFiles: 'Dateien',
        tabDisplay: 'Anzeige',

        // Categories tab
        tabCategories: 'Kategorien',
        catTitle: 'Ausgabenkategorien',
        catDescription: 'Passen Sie die Ausgabenkategorien für Ihre Rechnungen an. Das LLM verwendet diese zur automatischen Zuordnung bei der OCR-Verarbeitung.',
        catColLabel: 'Kategoriename',
        catColDesc: 'Beschreibung (LLM-Hinweis)',
        catLabelPlaceholder: 'Kategoriename',
        catLabelEn: 'Englisches Etikett',
        catDescPlaceholder: 'Welche Ausgabenarten umfasst diese?',
        catEdit: 'Bearbeiten',
        catDelete: 'Löschen',
        catAddRow: 'Zeile hinzufügen',
        catImport: 'Importieren',
        catImportTitle: 'Kategorien importieren',
        catImportDesc: 'Geben Sie eine Kategorie pro Zeile ein. Verwenden Sie | oder = als Trennzeichen für die Beschreibung.',
        catImportPlaceholder: 'Kategoriename | Beschreibung\nKategoriename = Beschreibung\nNur Kategoriename',
        catImportBtn: 'Hinzufügen',
        catCancelBtn: 'Abbrechen',
        catSave: 'Speichern',
        catSaving: 'Wird gespeichert...',
        catSaved: 'Kategorien erfolgreich gespeichert.',
        catError: 'Fehler beim Speichern der Kategorien.',
        catResetBtn: 'Auf Standard zurücksetzen',
        catResetConfirm: 'Alle benutzerdefinierten Kategorien werden entfernt und die Standardwerte wiederhergestellt. Sind Sie sicher?',
        catResetDone: 'Kategorien auf Standard zurückgesetzt.',
        catUnsavedChanges: 'Nicht gespeicherte Änderungen',
        catKeyDuplicate: 'Dieser Schlüssel existiert bereits',

        // DATEV settings
        tabDatev: 'DATEV',
        datevTitle: 'DATEV-Exporteinstellungen',
        datevDesc: 'Konfigurieren Sie diese Einstellungen, um Daten im DATEV-Format an Ihren Steuerberater zu senden.',
        datevBeraternr: 'Beraternummer',
        datevMandantennr: 'Mandantennummer',
        datevWjBeginn: 'Wirtschaftsjahr Beginn',
        datevSachkontenlaenge: 'Sachkontenlänge',
        datevGegenkonto: 'Gegenkonto',
        datevSkrType: 'Kontenrahmen',
        datevSave: 'Speichern',
        datevSaving: 'Wird gespeichert...',
        datevSaved: 'DATEV-Einstellungen gespeichert.',
        datevError: 'DATEV-Einstellungen konnten nicht gespeichert werden.',
        datevBeraternrHint: '4-7-stellige Zahl, mind. 1001',
        datevMandantennrHint: '1-5-stellige Zahl',
        datevGegenkontoHint: 'Nur Ziffern',

        // DATEV SKR Chart of Accounts (Kontenrahmen)
        datevChartTitle: 'SKR-Kontenrahmen',
        datevChartDesc: 'Der offizielle Kontenrahmen für den DATEV-Export. Fügen Sie hier Zeilen hinzu, entfernen oder bearbeiten Sie sie. Die KI wählt das Sachkonto bei der Rechnungsextraktion ausschließlich aus dieser Liste.',
        datevChartColKonto: 'Kontonummer',
        datevChartColLabel: 'Bezeichnung',
        datevChartColActions: '',
        datevChartAddRow: '+ Zeile hinzufügen',
        datevChartDeleteRow: 'Löschen',
        datevChartResetBtn: 'Auf Standard zurücksetzen',
        datevChartResetConfirm: 'Alle SKR03- und SKR04-Änderungen werden entfernt und die Standardwerte wiederhergestellt. Sind Sie sicher?',
        datevChartResetDone: 'Kontenrahmen auf Standard zurückgesetzt.',
        datevChartSaved: 'Kontenrahmen gespeichert.',
        datevChartInvalid: 'Kontonummer muss numerisch sein; Bezeichnung darf nicht leer sein.',
        datevChartDuplicate: 'Dieselbe Kontonummer darf nicht mehrfach verwendet werden.',
        datevChartEmpty: 'Die Liste muss mindestens ein Konto enthalten.',

        unsavedTitle: 'Nicht gespeicherte Änderungen',
        unsavedMessage: 'Sie haben nicht gespeicherte Änderungen. Wenn Sie diese Seite verlassen, gehen Ihre Änderungen verloren.',
        unsavedLeave: 'Verlassen',
        unsavedStay: 'Bleiben',

        // Theme section
        themeSection: 'Design-Einstellung',
        themeDescription: 'Wählen Sie das Erscheinungsbild Ihrer Oberfläche.',
        themeLight: 'Hell',
        themeDark: 'Dunkel',
        themeSystem: 'System',
        themeLightDesc: 'Klassische helle Oberfläche',
        themeDarkDesc: 'Augenschonende dunkle Oberfläche',
        themeSystemDesc: 'Geräteeinstellung übernehmen',

        // Profile section
        profileSection: 'Profilinformationen',
        profileName: 'Vollständiger Name',
        profileEmail: 'E-Mail-Adresse',
        profileSave: 'Änderungen speichern',
        profileSaving: 'Wird gespeichert...',
        profileSuccess: 'Profil erfolgreich aktualisiert.',
        profileError: 'Fehler beim Aktualisieren des Profils.',
        profileEmailInvalid: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',

        // Profile photo
        profilePhoto: 'Profilbild',
        uploadPhoto: 'Foto hochladen',
        removePhoto: 'Entfernen',
        photoUpdated: 'Foto aktualisiert.',
        photoError: 'Fehler beim Hochladen des Fotos.',
        photoTooLarge: 'Foto zu groß. Maximal 5 MB.',

        // Password section
        passwordSection: 'Passwort ändern',
        passwordDescription: 'Verwenden Sie ein sicheres Passwort, um Ihr Konto zu schützen.',
        setPasswordSection: 'Passwort festlegen',
        setPasswordDesc: 'Sie haben sich über SSO angemeldet und noch kein Passwort festgelegt. Legen Sie eines fest, um sich auch per E-Mail anmelden zu können.',
        setPasswordButton: 'Passwort festlegen',
        settingPassword: 'Wird festgelegt...',
        setPasswordSuccess: 'Passwort erfolgreich festgelegt.',
        currentPassword: 'Aktuelles Passwort',
        newPassword: 'Neues Passwort',
        confirmPassword: 'Neues Passwort bestätigen',
        changePassword: 'Passwort ändern',
        changingPassword: 'Wird geändert...',
        passwordSuccess: 'Passwort erfolgreich geändert.',
        passwordError: 'Fehler beim Ändern des Passworts.',
        passwordMismatch: 'Passwörter stimmen nicht überein.',
        passwordTooShort: 'Das Passwort muss mindestens 8 Zeichen lang sein.',
        passwordWrong: 'Aktuelles Passwort ist falsch.',

        // Language section
        languageSection: 'Spracheinstellung',
        languageDescription: 'Wählen Sie die Anzeigesprache der Anwendung.',
        languageTurkish: 'Türkçe',
        languageEnglish: 'English',
        languageGerman: 'Deutsch',

        // Date format section
        dateFormatSection: 'Datumsformat',
        dateFormatDescription: 'Wählen Sie, wie Daten angezeigt werden.',

        // Display currency section
        displayCurrencySection: 'Anzeigewährung',
        displayCurrencyDescription: 'Wählen Sie die Standardwährung für die Anzeige von Beträgen.',

        // Subscription section
        subscriptionSection: 'Abonnement & Credits',
        subscriptionDesc: 'Ihr aktueller Plan und Kaufoptionen.',
        currentPlan: 'Aktueller Plan',
        planFree: 'Kostenloser Plan',
        freePlanDesc: '50 Uploads/Monat + 5 Abgleiche/Monat',
        freePlanFeature1: '50 Dokument-Uploads pro Monat',
        freePlanFeature2: '5 Abgleiche pro Monat',
        freePlanFeature3: 'Automatische Periodenverlängerung',
        creditPackBadge: 'Kreditpaket',
        creditPackTitle: 'Credits kaufen',
        buyExtraCredits: 'Zusätzliche Credits kaufen',
        creditPackDesc: '€3 = 50 Dokumenten-Upload-Credits',
        monthlyUsage: 'Monatliche Nutzung',
        usageDescLifetime: 'Ihre Kontonutzung.',
        documentUploads: 'Dokumenten-Uploads',
        creditFeature1: '$5 = 100 Uploads + 20 Neuverarbeitungen',
        creditFeature2: 'Betrag frei wählbar',
        creditFeature3: 'Credits verfallen nie',
        creditPackScaleNote: 'Wählen Sie Ihren Betrag. Credits werden proportional berechnet.',
        creditPackPrice: 'Ab $5',
        buyCredits: 'Credits kaufen',
        checkoutLoading: 'Weiterleitung...',
        checkoutError: 'Checkout-Sitzung konnte nicht erstellt werden.',
        paymentSuccess: 'Zahlung erfolgreich! Ihre Credits wurden hinzugefügt.',
        paymentCancelled: 'Zahlung wurde abgebrochen.',
        paymentProcessing: 'Zahlung erhalten — wird abgeschlossen. Ihr Konto wird in wenigen Sekunden aktualisiert.',
        historyTitle: 'Kaufhistorie',
        historyEmpty: 'Noch keine Kaufhistorie vorhanden.',
        historyDate: 'Datum',
        historyAmount: 'Betrag',
        historyCredits: 'Credits',
        historyStatus: 'Status',
        historyUploads: 'Uploads',
        historyRegenerates: 'Neuverarbeitung',
        historyPerMonth: 'Monat',
        historyStatus_completed: 'Abgeschlossen',
        historyStatus_pending: 'Ausstehend',
        historyStatus_failed: 'Fehlgeschlagen',

        // Usage section
        usageTitle: 'Monatliche Nutzung',
        usageDescription: 'Ihr aktueller Nutzungsstatus.',
        freePlanUploads: 'Kostenlose Uploads',
        freePlanRematches: 'Kostenlose Abgleiche',
        usageResetsIn: 'Wird in {days} Tagen zurückgesetzt',
        usageUsed: 'genutzt',
        paidUploads: 'Gekaufte Upload-Credits',
        paidRegenerates: 'Gekaufte Neuverarbeitungs-Credits',
        usageLoadError: 'Nutzungsdaten konnten nicht geladen werden.',
        loading: 'Wird geladen...',
        quotaExceeded: 'Kontingent überschritten. Kaufen Sie Credits, um fortzufahren.',
        quotaModalTitle: 'Upload-Limit erreicht',
        quotaModalFree: 'Sie haben alle kostenlosen Uploads verbraucht. Upgraden Sie Ihren Plan.',
        quotaModalPaid: 'Ihre Upload-Credits sind aufgebraucht. Kaufen Sie weitere oder warten Sie auf die Zurücksetzung.',
        quotaModalUsed: 'Verwendet',
        quotaModalCredits: 'Verbleibende Credits',
        quotaModalResets: 'Ihr Kontingent wird in {days} Tagen zurückgesetzt ({date})',
        quotaModalUpgrade: 'Plan upgraden',
        quotaModalBuyCredits: 'Credits kaufen',
        quotaModalClose: 'Schließen',
        subscribe: 'Abonnieren',
        buyReconciliation: 'Credits kaufen',
        cancelSubscription: 'Abo kündigen',
        cancelSubscriptionConfirm: 'Sind Sie sicher? Ihr Abonnement wird am Ende des aktuellen Abrechnungszeitraums nicht verlängert. Sie können alle Funktionen bis dahin weiterhin nutzen. Danach wechselt Ihr Konto zum kostenlosen Plan.',
        managePayment: 'Zahlung verwalten',

        // Account section
        accountSection: 'Kontoinformationen',
        accountType: 'Kontotyp',
        accountTypeB2C: 'Privat',
        memberId: 'Mitgliedsnummer',
        memberSince: 'Mitglied seit',
        deleteAccountBtn: 'Konto löschen',
        deleteAccountTitle: 'Konto löschen',
        deleteAccountWarning: 'Diese Aktion ist dauerhaft und kann nicht rückgängig gemacht werden. Ihre Daten bleiben erhalten, aber Ihr Konto wird deaktiviert.',
        deleteAccountTypeHint: 'Geben Sie "delete" ein, um zu bestätigen',
        deleteAccountTypePlaceholder: 'delete',
        deleteAccountDeleting: 'Wird gelöscht...',
        deleteAccountConfirm: 'Mein Konto löschen',
        deleteAccountCancel: 'Abbrechen',
        deleteAccountError: 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.',
        deleteAccountFinalMessage: 'Sind Sie absolut sicher? Dies kann nicht rückgängig gemacht werden.',
        deleteAccountFinalConfirm: 'Ja, mein Konto löschen',
    },
};